<div class="log-title">
  <h1>Verify OTP</h1>
  <p>Please verify with the OTP sent to your email address</p>
  <p class="error">
    <span
      >Please check your SPAM Folder if you don't receive the OTP in your
      Inbox</span
    >
  </p>
</div>

<form [formGroup]="otpForm">
  <div class="row">
    <!-- Email Address -->
    <!-- <div class="col-lg-6 input-pad">
            <div class="mb-4">
                <input type="text" class="form-control" placeholder="Email address" formControlName="email" [class.is-invalid]="( !Global.isInputValid(otpForm, 'email') )">

                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(otpForm, 'email', 'required')">
                    <div>This field is required</div>
                </div>

                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(otpForm, 'email', 'email')">
                    <div>Please enter a valid email</div>
                </div>
            </div>
        </div> -->
    <div class="col-lg-6 input-pad">
      <div class="mb-4">
        <input
          type="text"
          class="form-control"
          [value]="emailToVerify"
          disabled
        />
      </div>
    </div>

    <!-- OTP Code -->
    <div class="col-lg-6 input-pad">
      <div class="mb-4">
        <input
          type="text"
          class="form-control"
          placeholder="Enter OTP Code"
          formControlName="otp_code"
          [class.is-invalid]="!Global.isInputValid(otpForm, 'otp_code')"
        />

        <div
          class="invalid-feedback"
          *ngIf="!Global.isInputRuleValid(otpForm, 'otp_code', 'required')"
        >
          <div>This field is required</div>
        </div>

        <div
          class="invalid-feedback"
          *ngIf="
            !Global.isInputRuleValid(otpForm, 'otp_code', 'pattern') ||
            !Global.isInputRuleValid(otpForm, 'otp_code', 'minlength') ||
            !Global.isInputRuleValid(otpForm, 'otp_code', 'maxlength')
          "
        >
          <div>The OTP code should be 6-Digits</div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <!-- Resend OTP Button -->
    <div
      class="col-lg-4 input-pad"
      *ngIf="['registration'].includes(verificationType)"
    >
      <button
        mat-button
        type="submit"
        (click)="resendOtp($event)"
        class="btn-secondary"
        id="resendotp-button"
      >
        <span class="indicator-label text-uppercase">Resend OTP</span>
        <span class="indicator-progress"
          >sending...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
      </button>
    </div>

    <!-- Submit Button -->
    <div
      class="input-pad"
      [ngClass]="
        ['registration'].includes(verificationType) ? 'col-lg-8' : 'col-lg-12'
      "
    >
      <button mat-button type="submit" (click)="submitOtp($event)">
        <span class="indicator-label text-uppercase">Verify Now</span>
        <span class="indicator-progress"
          >Please wait...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
      </button>
    </div>
  </div>
</form>
